module.exports = __webpack_public_path__ + "static/media/Dotted_Line.856e2749.png";